import { apiClient } from "../config";
async function detachSocialAccounts(data: any) {
  const res = await apiClient.post("/admin/detach-social-account", data);
  return res.data;
}

export default detachSocialAccounts;
